var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightMenu = function SvgRightMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#093451",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 25 25",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,0C5.6,0,0,5.6,0,12.5c0,3.4,1.4,6.7,3.8,9c2.2,2.1,5,3.3,8.1,3.5c0.2,0,0.3,0,0.5,0 c0,0,0,0,0.1,0c0,0,0,0,0.1,0c3.2,0,6.3-1.2,8.6-3.4c2.5-2.4,3.9-5.6,3.9-9.1C25,5.6,19.4,0,12.5,0z M20.9,20.3 c-0.5-1.6-2.6-2.5-4.3-3.2l-0.6-0.2C15,16.5,15,16.1,15,15.5c0-0.4,0.2-1,0.6-1.4c1-0.9,1.5-2,1.5-3.4C17.1,8,15.1,6,12.5,6 C9.9,6,8,7.9,8,10.7c0,1.4,0.5,2.6,1.4,3.4c0.4,0.4,0.6,1,0.6,1.4c0,0.4,0,0.9-1.3,1.5C7.1,17.6,5,18.5,4,20.2c-1.9-2.1-3-4.9-3-7.7 C1,6.2,6.2,1,12.5,1S24,6.2,24,12.5C24,15.4,22.9,18.2,20.9,20.3z"
  })));
};
export { SvgRightMenu as ReactComponent };